import { FormGroup, FormControl, Validators } from '@angular/forms';
import { RadicationDocsConfig } from './shared/radication-docs-config.service';
import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, OnDestroy } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import {
  Documento,
  Tarea,
  FuncionDocumento,
  TareaAsociacion,
  RadicadoCita,
  HistorialDocumento,
  DocumentoDetalle,
  Const,
  CondicionDocumento,
  Forma,
  Datos,
  SubForma,
  Control,
  ColumnsTableModalSelect,
  Static,
  TablaDatos,
  DatesCondiction
} from '@app/shared';
import { RadicationDocsDataService, GenerateRadication, RadicationYear, Dependencie } from './shared/radication-docs-data.service';
import { ToastrService } from 'ngx-toastr';
import { find, findIndex } from 'lodash';
import { LocalDataSource } from 'ng2-smart-table';
import { Logger } from '@app/core';
import { environment } from '@env/environment';
import { Subject } from 'rxjs';

const log: Logger = new Logger('RadicationDocsComponent');

@Component({
  selector: 'iw-radication-docs',
  templateUrl: './radication-docs.component.html',
  styleUrls: ['./radication-docs.component.scss'],
  providers: [RadicationDocsDataService]
})
export class RadicationDocsComponent implements OnInit, OnDestroy {

  // Label de las extensiones permitidas
  @Input() extensionsLabel = 'jpg, png, pdf, xlsx, xls, docx, doc, tiff, tif';
  // Variable que contiene el objeto de la tarea
  @Input() task: Tarea;
  // Define la finaliacioncion de la tarea
  @Input() finishTask = false;
  // Oculta o muestra el boton de regresar
  @Input() header: Boolean = false;
  // Oculta o muestra el titulo del componente
  @Input() title: Boolean = true;
  // Forma de la tarea
  @Input() form: Forma;
  // Variable que valida los tipos de documentos que se pueden subir
  @Input() extensions: string[] = [
    'image/tiff-fx',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf',
    'image/jpg',
    'image/png',
    'image/jpeg',
    'image/tif',
    'image/tiff',
  ];
  // Condiciones de acciones de los documentos en la tarea
  @Input() condictionsGenerate: Array<CondicionDocumento> = [];
  // Contiene los datos de todas las tablas inplicadas contando las tareas asociadas
  @Input() dataTableAll: TablaDatos[] = [];
  // Label de estenxiones para el accept del campo
  extensionsAccept = '';
  // Contiene el parametro de asociar
  association = false;
  // Contiene el parametro de generar
  generation = false;
  // Define si no es requerido subir el documento radicado
  notUploadDocument = false;
  // Define cuando esta subiendo un documento
  isLoading = false;
  // define cuando estan cargando los años de radicados disponibles
  isLoadingRadicationYear = false;
  // Define cuando debe mostrar el formulario de radicacion manual para carga de datos
  radicationManual = false;
  // Define cuando se esta generando o asociando el radicado
  loadingRadication = false;
  // Define si es radicado en CITA
  radiactionCita = '';
  // Contiene temporalmente el año seleccionado para la consulta de radicados
  tmpAnioSelect = '';
  // Key temporal del radicado seleccionado
  tmpKeyDocCita = '';
  // Ruta de generacion de rotulo
  urlGenrationRotulo = Const.ROUTES_SYSTEM_INTEGRATIONS.cita.urlGenrationRotulo;
  // Ruta de generacion de la mascara del expediente
  urlGenrationMascara = Const.ROUTES_SYSTEM_INTEGRATIONS.cita.urlGenrationCaratula;
  // Contiene temporalmente el consecutivo ingresado
  tmpConsecutiveRadication: number = null;
  // Variable para ocultar el formulario
  hideForm = true;
  // Define si se genera o asocia el radicado
  generateRadicate = true;
  // Variable para ocultar el formulario
  hiddeDateRadication = true;
  // Define cuando se estan consultando los radicados
  loadingSearchRadications = false;
  // Define si el formulario de generar radicado contiene indices
  indices = environment.servers_integrations.CITA.INDICES;
  // Variable que contendrá los documentos.
  documents: Array<Documento> = [];
  // Datos para llenar la tabla
  source: LocalDataSource;
  // Radicados consultados de cita
  searchRadications: Array<RadicadoCita> = [];
  // Clmacena los documentos que se van a subir.
  documentsUpload: any[] = [];
  // Variable a la cual se le injectan las configuraciones de la tabla.
  settings = {};
  // Contiene las validaciones por documento
  condictionsDoc = {};
  // Variable contendrá la información de la fila seleccionada en la tabla
  rowSelect: Documento;
  // lista de los años de los radicados disponibles
  radicationYear: RadicationYear[];
  // Lista de dependencias disponibles
  dependencies: Dependencie[];
  // Variable que controla el id de la dependencia seleccionada
  selectedDependencie: number;
  // Variable de control de muestra de selector dependencia para radicado
  controlDependencies: boolean = false;
  // variable que contiene toda la data del documento.
  formData = new FormData();
  // Variable que contendrá el formulario de fechas.
  formFechas: FormGroup = new FormGroup({
    anio: new FormControl('', [Validators.required]),
    consecutive: new FormControl(null),
    radication: new FormControl('', [Validators.required]),
    dateRadication: new FormControl(''),
  });
  // Variable que contendrá el formulario de generar radicado.
  formGenerateRadicate: FormGroup = new FormGroup({
    numFolios: new FormControl(1, [Validators.required]),
  });
  // Variable que contendrá el formulario de fechas.
  formRadicate: FormGroup = new FormGroup({
    radicate: new FormControl('', [Validators.required]),
    dateRadicate: new FormControl('', [Validators.required])
  });
  // Variable que contiene la instancia de la modal del suir documento
  modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Variable que verifica si los documentos ya se radicadon
  @Output() radicateCompleted: EventEmitter<boolean> = new EventEmitter();
  // Variable que verifica si los documentos ya se radicadon
  @Output() taskUpdate: EventEmitter<Tarea> = new EventEmitter();
  // Evento que emite al presionar el boton de regresar
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  columnsSelect: Array<ColumnsTableModalSelect> = [
    {
      key: 'radicado',
      label: 'Radicado'
    },
    {
      key: 'fecha',
      label: 'Fecha',
      type: 'dateString',
      view: false
    },
  ];
  

  constructor(
    private rdds: RadicationDocsDataService,
    private toastr: ToastrService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.formFechas.controls['dateRadication'].disable();
    this.formFechas.controls['radication'].valueChanges.subscribe(((data: any) => {
      // Se asigna la fecha de radicado al campo correspondiente cuando este se selecciona
      if (this.searchRadications && this.searchRadications.length) {
        const rowSelect = find(this.searchRadications, {iddocumento: data});
        if (rowSelect && rowSelect.fecha) {
          this.formFechas.controls['dateRadication'].setValue(new Date(rowSelect.fecha + ' 00:00:00'));
        } else {
          this.formFechas.controls['dateRadication'].setValue(null);
        }
      } else {
        this.formFechas.controls['dateRadication'].setValue(null);
      }
    }));
    for (let i = 0; i < this.extensions.length; i++) {
      this.extensionsAccept += this.extensions[i];
      if (i !== (this.extensions.length - 1)) {
        this.extensionsAccept += ', ';
      }
    }

    // Se valida si en los parametros de la tarea viene la propiedad de asociar
    if (this.task.tarea_forma[0].parametros.asociar) {
      this.association = this.task.tarea_forma[0].parametros.asociar;
    }
    // Se valida si en los parametros de la tarea viene la propiedad de generar
    if (this.task.tarea_forma[0].parametros.generar) {
      this.generation = this.task.tarea_forma[0].parametros.generar;
    } else if (this.task.tarea_forma[0].parametros.generar_sin_subir) {
      this.generation = this.task.tarea_forma[0].parametros.generar_sin_subir;
      this.notUploadDocument = true;
    }
    // Se valida si en los parámetros de la tarea contiene la propiedad de seleccionar dependencia para generar radicado
    if(this.task.tarea_forma[0].parametros.requerir_dependencia){
      this.controlDependencies = this.task.tarea_forma[0].parametros.requerir_dependencia;
    }
    // Validacion de las condiciones del documento
    if (
      this.form &&
      this.form.estilo &&
      this.form.estilo['condiciones_documentos'] &&
      this.form.estilo['condiciones_documentos'].length
    ) {
      this.form.estilo['condiciones_documentos'].forEach((condictionDoc: CondicionDocumento) => {
        if (condictionDoc.formaDocumento) {
          if (!this.condictionsDoc.hasOwnProperty(condictionDoc.formaDocumento)) {
            this.condictionsDoc[condictionDoc.formaDocumento] = {};
          }
          if (!this.condictionsDoc[condictionDoc.formaDocumento].hasOwnProperty(condictionDoc['documento_nombre'])) {
            this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']] = {
              condictionsRadication: [],
              condictionsGenerate: [],
            };
          }
          switch (condictionDoc.accionDocumento) {
            case 'radicar':
              // tslint:disable-next-line:max-line-length
              this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsRadication.push(condictionDoc);
              break;
            case 'generar':
              // tslint:disable-next-line:max-line-length
              this.condictionsDoc[condictionDoc.formaDocumento][condictionDoc['documento_nombre']].condictionsGenerate.push(condictionDoc);
              break;
          }
        }
      });
    }

    this.formRadicate.disable();
    const docsC = new RadicationDocsConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe((data: any) => {
      // this.buttonAction = true;
      this.actionTable(data);
    });
    this.loadingDocs();
    this.formFechas.valueChanges.subscribe(data => {
      // Se valida que las fechas esten seleccionadas y un radicao seleccionado
      // para verificar si tiene documento en cita y asignar la key del documento para descargarlo
      if (data.radication) {
        const docSelect = find(this.searchRadications, {iddocumento: data.radication});
        if (docSelect) {
          if (this.tmpKeyDocCita !== docSelect.nombre_archivo) {
            this.tmpKeyDocCita = docSelect.nombre_archivo;
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Consulta los radicados de las fechas seleccionadas y el consecutivo ingresado
   *
   * @memberof RadicationDocsComponent
   */
  consultRadications() {
    if (this.formFechas.controls['anio'].value) {
      const consecutive = Number(this.formFechas.controls['consecutive'].value);
      if (
        this.tmpAnioSelect !== this.formFechas.controls['anio'].value ||
        this.tmpConsecutiveRadication !== consecutive
      ) {
        this.searchRadications = [];
        this.tmpAnioSelect = this.formFechas.controls['anio'].value;
        this.tmpConsecutiveRadication = consecutive;
        this.formFechas.disable();
        this.loadingSearchRadications = true;
        this.formFechas.controls['radication'].reset();
        this.tmpKeyDocCita = '';
        this.rdds.getRadicationsCita(
          this.formFechas.controls['anio'].value,
          Number(this.rowSelect.codigo_documento),
          this.formFechas.controls['consecutive'].value
        ).subscribe((dataDoc: any) => {
          this.searchRadications = dataDoc;
          this.formFechas.enable();
          this.loadingSearchRadications = false;
        }, () => {
          this.searchRadications = [];
          this.formFechas.enable();
          this.loadingSearchRadications = false;
        });
      }
    }
  }

  /**
   * Controla la accion de descargar en el boton de la tabla
   *
   * @param {*} data
   * @memberof RadicationDocsComponent
   */
  actionTable(data: any) {
    if (data.accion === 'download') {
      if (data.data['documento_cita']) {
        const a = document.createElement('a');
        a.href = Const.ROUTES_SYSTEM_INTEGRATIONS.cita.dowloadDocument + data.data['documento_cita'];
        a.click();
        a.remove();
      } else if (data.data['id_documento']) {
        this.download(data.data['id_documento']);
      }
    } else if (data.accion === 'generate') {
      this.generateDocument(data.data);
    } else if (data.accion === 'caratula') {
      this.generactionRotulo(
        data.data.documentos_detalle[0].id_documento,
        data.data.documentos_detalle[0].id_documento_cita
      )
    } else if (data.accion === 'error') {
      this.toastr.error(data.message, 'Error de accion');
    }
  }

  /**
   * Controla el evento de click a las filas de la tabla
   * Para mostrar el formulario de radicacion o el de vista de radicado
   *
   * @param {*} [data=null]
   * @memberof RadicationDocsComponent
   */
  clikRowSelect(data: any = null) {
    if (
      (!this.rowSelect && this.searchRadications.length) ||
      (
        this.rowSelect &&
        this.rowSelect.clasificacion_id !== data.clasificacion_id &&
        this.rowSelect.idtarea !== data.idtarea
      )
    ) {
      this.tmpAnioSelect = '';
      this.searchRadications = null;
    }
    const funtionRadication: any = find(data.data.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.radication});
    if (funtionRadication) {
      if (this.association || this.generation) {
        this.hideForm = true;
        this.hiddeDateRadication = true;
        this.generateRadicate = this.generation;
        this.documentsUpload = [];
        this.formData = new FormData();
        this.formGenerateRadicate.controls['numFolios'].setValue(1);
        this.formData.append('id_tarea', String(this.task.id));
        if (this.indices && (data && !data.data.expediente)) {
          if(this.controlDependencies){
              this.formGenerateRadicate = new FormGroup({
                txtDescripcion: new FormControl('', [Validators.required]),
                numFolios: new FormControl(1, [Validators.required]),
                txtAnexos: new FormControl('', []),
                slctDependencies: new FormControl(null, [Validators.required]),
              });
              }
          else{
                this.formGenerateRadicate = new FormGroup({
                txtDescripcion: new FormControl('', [Validators.required]),
                numFolios: new FormControl(1, [Validators.required]),
                txtAnexos: new FormControl('', []),
              });
                }
        } else {
          if(this.controlDependencies){
            this.formGenerateRadicate = new FormGroup({
              numFolios: new FormControl(1, [Validators.required]),
              slctDependencies: new FormControl(null, [Validators.required])
            });
          }
          else{
            this.formGenerateRadicate = new FormGroup({
              numFolios: new FormControl(1, [Validators.required])
            });
          } 
        }
        if (data.data.documentos_detalle.length) {
          this.hideForm = false;
          if (data) {
            this.rowSelect = {
              clasificacion_id: data.data.clasificacion_id,
              clasificacion: data.data.clasificacion,
              codigo_documento: data.data.codigo_documento,
              documentos_detalle: [],
              funciones: data.data.funciones,
              id_tipo_documental: data.data.id_tipo_documental,
              ruta_generacion: data.data.ruta_generacion,
              ruta_vista_previa: data.data.ruta_vista_previa,
              tipo_documental: data.data.tipo_documental,
              documento: data.data.documento,
              idtarea: data.data.idtarea,
              expediente: data.data.expediente,
              id_expediente_cita: data.data.id_expediente_cita,
            };
            if (data.data.documentos_detalle && data.data.documentos_detalle.length) {
              data.data.documentos_detalle.forEach((docDetail: DocumentoDetalle) => {
                this.rowSelect.documentos_detalle.push(docDetail);
              });
            }
            this.formFechas.reset();
          }
          if (this.rowSelect) {
            if (!this.rowSelect.documentos_detalle[0].radicado) {
              if (this.finishTask) {
                this.hideForm = true;
              } else {
                this.hiddeDateRadication = true;
                let date: Date;
                if (this.rowSelect.documentos_detalle[0].fecha instanceof Date) {
                  date = this.rowSelect.documentos_detalle[0].fecha;
                } else {
                  const radicate = String(this.rowSelect.documentos_detalle[0].fecha).split('T');
                  const splitDate = radicate[0].split('-');
                  date = new Date(
                    Number(splitDate[0]),
                    (Number(splitDate[1]) - 1),
                    Number(splitDate[2]),
                    0, 0, 0, 0
                  );
                }
                this.formRadicate.controls['radicate'].setValue(this.rowSelect.documentos_detalle[0].radicado);
                this.formRadicate.controls['dateRadicate'].setValue(date);
                this.hiddeDateRadication = false;
              }
            } else {
              this.hiddeDateRadication = true;
              let date: Date;
              if (this.rowSelect.documentos_detalle[0].fecha instanceof Date) {
                date = this.rowSelect.documentos_detalle[0].fecha;
              } else {
                const radicate = String(this.rowSelect.documentos_detalle[0].fecha).split('T');
                const splitDate = radicate[0].split('-');
                date = new Date(
                  Number(splitDate[0]),
                  (Number(splitDate[1]) - 1),
                  Number(splitDate[2]),
                  0, 0, 0, 0
                );
              }
              this.formRadicate.controls['radicate'].setValue(this.rowSelect.documentos_detalle[0].radicado);
              this.formRadicate.controls['dateRadicate'].setValue(date);
            }
          }
        } else {
          if (data) {
            this.rowSelect = {
              clasificacion_id: data.data.clasificacion_id,
              clasificacion: data.data.clasificacion,
              codigo_documento: data.data.codigo_documento,
              documentos_detalle: [],
              funciones: data.data.funciones,
              id_tipo_documental: data.data.id_tipo_documental,
              ruta_generacion: data.data.ruta_generacion,
              ruta_vista_previa: data.data.ruta_vista_previa,
              tipo_documental: data.data.tipo_documental,
              documento: data.data.documento,
              idtarea: data.data.idtarea,
              expediente: data.data.expediente,
              id_expediente_cita: data.data.id_expediente_cita,
            };
            if (data.data.documentos_detalle && data.data.documentos_detalle.length) {
              data.data.documentos_detalle.forEach((docDetail: DocumentoDetalle) => {
                this.rowSelect.documentos_detalle.push(docDetail);
              });
            }
            this.formFechas.reset();
          }
          if (!this.finishTask) {
            this.hideForm = false;
            this.hiddeDateRadication = false;
          }
        }
        if (this.association && this.rowSelect && !this.rowSelect.expediente && !this.hiddeDateRadication) {
          this.isLoadingRadicationYear = true;
          this.rdds.getRadicationYears(this.rowSelect.codigo_documento).subscribe(years => {
            this.radicationYear = years;
            this.isLoadingRadicationYear = false;
          });
        }if (this.generation && this.rowSelect && !this.hiddeDateRadication) {
          this.rdds.getDependencies().subscribe(dep => {
            this.dependencies = dep;
          });
        }
      } else {
        this.toastr.warning(
          'La tarea no contiene ninguna acción para realizar con los documentos.',
          'Acción no permitida'
        );
      }
    }
  }

  /**
   * Descarga el documento de cita
   *
   * @memberof RadicationDocsComponent
   */
  dowloadDocCita() {
    if (this.tmpKeyDocCita) {
      const a = document.createElement('a');
      a.href = Const.ROUTES_SYSTEM_INTEGRATIONS.cita.dowloadDocument + this.tmpKeyDocCita;
      a.click();
      a.remove();
    } else {
      this.toastr.warning('El radicado no contiene documento', 'Alerta de descarga', {
        positionClass: 'toast-top-center'
      });
    }
  }

  /**
   * Abre la ruta para visalizar el rotulo para los expedientes
   *
   * @memberof RadicationDocsComponent
   */
  generactionRotulo(idDocument: number, idDocumentCita: number) {
    this.rdds.getInfoRecordCover(idDocument).subscribe((info: any) => {
      const a = document.createElement('a');
      a.href = this.urlGenrationMascara + idDocumentCita + '&parametros=' + info;
      a.target = '_blank';
      a.click();
      a.remove();
    });
  }

  /**
   * Ejecuta la radicacion del documento seleccionado
   *
   * @memberof RadicationDocsComponent
   */
  async Radication() {
    if (!this.generateRadicate && this.formFechas.valid && this.formFechas.controls['radication'].value) {
      this.formFechas.disable();
      const docSelect = find(this.searchRadications, {iddocumento: this.formFechas.controls['radication'].value});
      if (docSelect) {
        const formData = {
          radicado: docSelect.radicado,
          fecha: new Date(docSelect.fecha + ' 00:00:00'),
          tarea: this.rowSelect.idtarea,
          documento_cita: docSelect.nombre_archivo,
          id_documento_cita: docSelect.iddocumento
        };
        let radication: GenerateRadication;
        if (this.rowSelect.documentos_detalle.length && this.rowSelect.documentos_detalle[0].id_documento) {
          radication = await this.rdds.setRadication(formData, this.rowSelect.documentos_detalle[0].id_documento)
           .catch(error => {
             this.formFechas.enable();
             return null;
           });
        } else {
          formData['clasificacion_documentos'] = this.rowSelect.clasificacion_id;
          radication = await this.rdds.setRadication(formData).catch(error => {
            this.formFechas.enable();
            return null;
          });
        }
        if (radication) {
          if (this.rowSelect.documentos_detalle.length) {
            this.documents.forEach(doc => {
              if (doc.clasificacion_id === this.rowSelect.clasificacion_id) {
                doc.documentos_detalle[0].radicado = docSelect.radicado;
                doc.documentos_detalle[0].fecha = new Date(docSelect.fecha + ' 00:00:00');
                doc.documentos_detalle[0].documento_cita = docSelect.nombre_archivo;
                doc.documentos_detalle[0].id_documento_cita = docSelect.iddocumento;
                doc.documentos_detalle[0].id_documento = radication.id;
              }
            });
            this.rowSelect.documentos_detalle[0].radicado = docSelect.radicado;
            this.rowSelect.documentos_detalle[0].fecha = new Date(docSelect.fecha + ' 00:00:00');
            this.rowSelect.documentos_detalle[0].documento_cita = docSelect.nombre_archivo;
            this.rowSelect.documentos_detalle[0].id_documento_cita = docSelect.iddocumento;
            this.rowSelect.documentos_detalle[0].id_documento = radication.id;
            this.hiddeDateRadication = true;
            const radicate = this.rowSelect.documentos_detalle[0].fecha.toLocaleDateString().split('T');
            const splitDate = radicate[0].split('/');
            const date: Date = new Date(
              Number(splitDate[2]),
              (Number(splitDate[1]) - 1),
              Number(splitDate[0]),
              0, 0, 0, 0
            );
            this.formRadicate.controls['radicate'].setValue(this.rowSelect.documentos_detalle[0].radicado);
            this.formRadicate.controls['dateRadicate'].setValue(date);
          } else {
            this.documents.forEach(doc => {
              if (doc.clasificacion_id === this.rowSelect.clasificacion_id) {
                doc.documentos_detalle.push({
                  radicado: docSelect.radicado,
                  fecha: new Date(docSelect.fecha + ' 00:00:00'),
                  documento_cita: docSelect.nombre_archivo,
                  id_documento_cita: docSelect.iddocumento,
                  id_documento: radication.id,
                  historial: []
                });
              }
            });
            this.rowSelect.documentos_detalle.push({
              radicado: docSelect.radicado,
              fecha: new Date(docSelect.fecha + ' 00:00:00'),
              documento_cita: docSelect.nombre_archivo,
              id_documento_cita: docSelect.iddocumento,
              id_documento: radication.id,
              historial: []
            });
            this.hiddeDateRadication = true;
            const radicate = this.rowSelect.documentos_detalle[0].fecha.toLocaleDateString().split('T');
            const splitDate = radicate[0].split('/');
            const date: Date = new Date(
              Number(splitDate[2]),
              (Number(splitDate[1]) - 1),
              Number(splitDate[0]),
              0, 0, 0, 0
            );
            this.formRadicate.controls['radicate'].setValue(this.rowSelect.documentos_detalle[0].radicado);
            this.formRadicate.controls['dateRadicate'].setValue(date);
          }
          this.source = new LocalDataSource(this.documents);
          this.source.refresh();
        }
      }
      this.validateRadicateDocuments();
      this.updateDocuments();
      this.formFechas.enable();
    } else if (this.generateRadicate && this.formGenerateRadicate.valid) {
      this.formGenerateRadicate.disable();
      let radication: GenerateRadication;
      if (this.indices && !this.rowSelect.expediente) {
        const indicesText = [
          this.formGenerateRadicate.controls['txtDescripcion'].value,
          this.formGenerateRadicate.controls['numFolios'].value,
          this.formGenerateRadicate.controls['txtAnexos'].value
        ];
        if(this.controlDependencies){
          radication = await this.rdds.generateRadication(
            this.formGenerateRadicate.controls['numFolios'].value,
            this.rowSelect.idtarea,
            this.rowSelect.clasificacion_id,
            indicesText,
            this.selectedDependencie
        ).catch(error => {
          this.formGenerateRadicate.enable();
            return null;
          });
          }else{
          radication = await this.rdds.generateRadication(
            this.formGenerateRadicate.controls['numFolios'].value,
            this.rowSelect.idtarea,
            this.rowSelect.clasificacion_id,
            indicesText,
            this.selectedDependencie
        ).catch(error => {
          this.formGenerateRadicate.enable();
          return null;
          });
        }
      } else {
        if(this.controlDependencies){
          radication = await this.rdds.generateRadication(
            this.formGenerateRadicate.controls['numFolios'].value,
            this.rowSelect.idtarea,
            this.rowSelect.clasificacion_id,
            null,
            this.selectedDependencie
          ).catch(error => {
            this.formGenerateRadicate.enable();
            return null;
          });
        }
        else{
          radication = await this.rdds.generateRadication(
            this.formGenerateRadicate.controls['numFolios'].value,
            this.rowSelect.idtarea,
            this.rowSelect.clasificacion_id
          ).catch(error => {
            this.formGenerateRadicate.enable();
            return null;
          });
         }
        }
        

      this.formGenerateRadicate.enable();
      if (radication) {
        this.formGenerateRadicate.controls['numFolios'].setValue(1);
        if (this.rowSelect.documentos_detalle.length) {
          this.documents.forEach(doc => {
            if (doc.clasificacion_id === this.rowSelect.clasificacion_id) {
              doc.documentos_detalle[0].radicado = radication.radicado;
              doc.documentos_detalle[0].fecha = new Date(radication.fecha + ' 00:00:00');
              doc.documentos_detalle[0].documento_cita = radication.documento_cita;
              doc.documentos_detalle[0].id_documento_cita = radication.id_documento_cita;
              doc.documentos_detalle[0].id_documento = radication.id;
            }
          });
          this.rowSelect.documentos_detalle[0].radicado = radication.radicado;
          this.rowSelect.documentos_detalle[0].fecha = new Date(radication.fecha + ' 00:00:00');
          this.rowSelect.documentos_detalle[0].documento_cita = radication.documento_cita;
          this.rowSelect.documentos_detalle[0].id_documento_cita = radication.id_documento_cita;
          this.rowSelect.documentos_detalle[0].id_documento = radication.id;
          this.hiddeDateRadication = true;
          const radicate = this.rowSelect.documentos_detalle[0].fecha.toLocaleDateString().split('T');
          const splitDate = radicate[0].split('/');
          const date: Date = new Date(
            Number(splitDate[2]),
            (Number(splitDate[1]) - 1),
            Number(splitDate[0]),
            0, 0, 0, 0
          );
          this.formRadicate.controls['radicate'].setValue(this.rowSelect.documentos_detalle[0].radicado);
          this.formRadicate.controls['dateRadicate'].setValue(date);
        } else {
          this.documents.forEach(doc => {
            if (doc.clasificacion_id === this.rowSelect.clasificacion_id) {
              doc.documentos_detalle.push({
                radicado: radication.radicado,
                fecha: new Date(radication.fecha + ' 00:00:00'),
                documento_cita: radication.documento_cita,
                id_documento_cita: radication.id_documento_cita,
                id_documento: radication.id,
                historial: []
              });
            }
          });
          this.rowSelect.documentos_detalle.push({
            radicado: radication.radicado,
            fecha: new Date(radication.fecha + ' 00:00:00'),
            documento_cita: radication.documento_cita,
            id_documento_cita: radication.id_documento_cita,
            id_documento: radication.id,
            historial: []
          });
          this.hiddeDateRadication = true;
          const radicate = this.rowSelect.documentos_detalle[0].fecha.toLocaleDateString().split('T');
          const splitDate = radicate[0].split('/');
          const date: Date = new Date(
            Number(splitDate[2]),
            (Number(splitDate[1]) - 1),
            Number(splitDate[0]),
            0, 0, 0, 0
          );
          this.formRadicate.controls['radicate'].setValue(this.rowSelect.documentos_detalle[0].radicado);
          this.formRadicate.controls['dateRadicate'].setValue(date);
        }
        this.source = new LocalDataSource(this.documents);
        this.source.refresh();
      }
      this.formGenerateRadicate.disable();
      this.validateRadicateDocuments();
      this.updateDocuments();
    }
  }

  /**
   * Sube el documento al sistema y crea un nuevo historial
   *
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  uploadDocs(): any {
    if (this.documentsUpload && this.documentsUpload.length) {
      this.isLoading = true;
      this.formData.append('documentos', JSON.stringify(this.documentsUpload));
      this.rdds.uploadFile(this.formData).subscribe((res: any) => {
        this.isLoading = false;
        if (res.length === 0) {
          console.error('Fallo del sistema');
        } else {
          this.documentsUpload = [];
          this.formData = new FormData();
          this.formData.append('id_tarea', String(this.rowSelect.idtarea));
          for (let i = 0; i < res.length; i++) {
            for (let s = 0; s < this.documents.length; s++) {
              if (
                res[i]['clasificacion_documento_id'] === this.documents[s].clasificacion_id &&
                res[i]['id_tarea'] === this.documents[s].idtarea
              ) {
                let indexDetalle: number = this.documents[s].documentos_detalle.length - 1;
                let versionDoc = 0;
                if (indexDetalle > 0) {
                  versionDoc = this.documents[s].documentos_detalle[indexDetalle].historial.length + 1;
                }
                const historyDocument: HistorialDocumento = {
                  id: res[i]['id'],
                  nombre: res[i]['nombre'],
                  nombre_archivo: res[i]['nombre_archivo'],
                  extension: res[i]['extension'],
                  version: res[i]['version'],
                  revision: [],
                  radicado: res[i]['radicado']
                };
                if (indexDetalle < 0) {
                  this.documents[s].documentos_detalle.push({
                    id_documento: res[i]['documento_id'],
                    historial: []
                  });
                  indexDetalle = this.documents[s].documentos_detalle.length - 1;
                } else {
                  this.documents[s].documentos_detalle[indexDetalle].id_documento = res[i]['documento_id'];
                }
                if (versionDoc === 0) {
                  versionDoc = 1;
                }

                this.documents[s].documentos_detalle[indexDetalle].historial.push(historyDocument);
                break;
              }
            }
          }
          this.source = new LocalDataSource(this.documents);
          this.source.refresh();
          this.modalRef.hide();
          this.validateRadicateDocuments();
          this.updateDocuments();
        }
      },
      err => {
        this.isLoading = false;
      });
    }
  }

  /**
   * Abre la modal indicada
   *
   * @param {TemplateRef<any>} template
   * @memberof RadicationDocsComponent
   */
  async openModalWithClass(template: TemplateRef<any>) {
    this.modalRef = await this.modalService.show(template, Object.assign({}, { class: 'gray modal-lg' }));
  }

  /**
   * Controla las acciones del componente de documentos
   *
   * @param {*} data
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  onAction(data: any): any {
    if (data.action === 1) {
      this.onAdded(data);
    } else if (data.action === 0) {
      this.onRemoved(data);
    }
  }

  /**
   * Carga los documentos de la tarea y asociados para radicar
   *
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  loadingDocs(): any {
    let functionsDocuments: Array<FuncionDocumento>;
    let objTaskAssociation: Array<TareaAsociacion>;
    if (this.rowSelect) {
      this.rowSelect = null;
      this.hideForm = true;
    }
    if (this.task.documentos.length) {
      this.task.documentos.forEach(doc => {
        if (doc.funciones) {
          functionsDocuments = doc.funciones;
          functionsDocuments.forEach(functionDocument => {
            if (functionDocument.funcion) {
              if (functionDocument.funcion === Const.DOCUMENTS_FUNCTIONS.radication) {
                const copyDoc: Documento = Static.copyObjet(doc);
                if (copyDoc) {
                  copyDoc.idtarea = this.task.id;
                  this.documents.push(copyDoc);
                }
              }
            }
          });
        }
      });
    }
    if (this.task.tarea_asociacion) {
      objTaskAssociation = this.task.tarea_asociacion;
      objTaskAssociation.forEach(association => {
        if (association.documentos) {
          // this.documents = association.documentos;
          association.documentos.forEach(document => {
            if (document.funciones) {
              functionsDocuments = document.funciones;
              functionsDocuments.forEach(functionDocument => {
                if (functionDocument.funcion) {
                  if (functionDocument.funcion === Const.DOCUMENTS_FUNCTIONS.radication) {
                    const copyDoc: Documento = Static.copyObjet(document);
                    if (copyDoc) {
                      copyDoc.idtarea = association.id_tarea_destino;
                      this.documents.push(copyDoc);
                    }
                  }
                }
              });
            }
          });
        }
      });
    }
    if (this.documents && this.documents.length) {
      const copyDocuments: Documento[] = [];
      this.documents.forEach(doc => {
        if (doc.idtarea === this.task.id) {
          if (
            this.form &&
            this.condictionsDoc[this.form.alias] &&
            this.condictionsDoc[this.form.alias][doc.clasificacion]
          ) {
            if (doc.funciones && doc.funciones.length) {
              const functions: FuncionDocumento[] = Static.copyObjet(doc.funciones);
              functions.forEach(funtion => {
                switch (funtion.funcion) {
                  case Const.DOCUMENTS_FUNCTIONS.radication:
                    this.validCondictionsDoc(
                      this.condictionsDoc[this.form.alias][doc.clasificacion]['condictionsRadication'],
                      doc,
                      funtion.funcion
                    );
                    break;
                  case Const.DOCUMENTS_FUNCTIONS.generate:
                    this.validCondictionsDoc(
                      this.condictionsDoc[this.form.alias][doc.clasificacion]['condictionsGenerate'],
                      doc,
                      funtion.funcion
                    );
                    break;
                }
              });
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const taskAssociation = find(this.task.tarea_asociacion, {id_tarea_destino: doc.idtarea});
            if (
              taskAssociation &&
              this.condictionsDoc[taskAssociation.alias] &&
              this.condictionsDoc[taskAssociation.alias][doc.clasificacion]
            ) {
              if (doc.funciones && doc.funciones.length) {
                const functions: FuncionDocumento[] = Static.copyObjet(doc.funciones);
                functions.forEach(funtion => {
                  switch (funtion.funcion) {
                    case Const.DOCUMENTS_FUNCTIONS.radication:
                      this.validCondictionsDoc(
                        this.condictionsDoc[taskAssociation.alias][doc.clasificacion]['condictionsRadication'],
                        doc,
                        funtion.funcion
                      );
                      break;
                    case Const.DOCUMENTS_FUNCTIONS.generate:
                      this.validCondictionsDoc(
                        this.condictionsDoc[taskAssociation.alias][doc.clasificacion]['condictionsGenerate'],
                        doc,
                        funtion.funcion
                      );
                      break;
                  }
                });
              }
            }
          }
        }
      });
      this.validCondictionsGenerateDocs();
      this.documents.forEach(doc => {
        if (doc.funciones && doc.funciones.length) {
          let functionExist: FuncionDocumento;
          functionExist = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.radication});
          if (functionExist) {
            copyDocuments.push(doc);
          } else {
            functionExist = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.generate});
            if (functionExist) {
              copyDocuments.push(doc);
            }
          }
        }
      });
      this.documents = copyDocuments;
    }
    this.source = new LocalDataSource(this.documents);
    this.source.refresh();
    this.validateRadicateDocuments();
  }

  /**
   * Descarga del documento de cinco
   *
   * @private
   * @param {number} data
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  private download(data: number): any {
    this.rdds.dowloadFile(data).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }

  /**
   * Validacion de las condiciones de los documentos para la funcion de Generar
   *
   * @private
   * @memberof RadicationDocsComponent
   */
  private validCondictionsGenerateDocs() {
    let valid = true;
    if (this.condictionsGenerate && this.condictionsGenerate.length) {
      let valView = false;
      let valHide = false;
      let firstView = true;
      let firstHide = true;
      let operactorNext = 'O';
      this.condictionsGenerate.forEach(condiction => {
        let date = false;
        let comply = false;
        let value: Datos = null;
        let formulario: SubForma;
        let control: Control;
        let valor: any;
        const moment = require('moment');
        if (!Number(condiction.valor)) {
          if (condiction.valor &&  moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        if (this.form && this.form.alias === condiction.forma) {
          formulario = find(this.form.sub_formas, {alias: condiction.formulario});
          if (formulario) {
            control = find(formulario.campos, {alias: condiction.campo});
            if (control) {
              if (this.task.datos && this.task.datos.length) {
                value = find(this.task.datos, {nombre_campo: control.nombre_campo});
              }
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const tasAssociation = find(this.task.tarea_asociacion, {alias: condiction.forma});
            if (tasAssociation) {
              if (tasAssociation.datos && tasAssociation.datos.length) {
                value = find(tasAssociation.datos, {alias_formulario: condiction.formulario, alias: condiction.campo});
              }
            }
          }
        }
        if (value) {
          valor = value.valor;
        }
        switch (condiction.siEs) {
          case 'Vacio':
            if (
              !valor ||
              valor === ''
            ) {
              comply = true;
            } else {
              comply = false;
            }
            break;
          case 'Diferente':
            if (!date) {
              if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl !== valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
          case 'Mayor a':
            if (!date) {
              if (Number(valor) > Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl > valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Mayor o igual a':
            if (!date) {
              if (Number(valor) >= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl >= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor a':
            if (!date) {
              if (Number(valor) < Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl < valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor o igual a':
            if (!date) {
              if (Number(valor) <= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl <= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          default:
            if (!date) {
              if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl === valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
        }
        switch (condiction.accion) {
          case 'Mostrar':
            if (!firstView) {
              if (!operactorNext || operactorNext === 'O') {
                if (valView || comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              } else {
                if (valView && comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              }
            } else {
              firstView = false;
              firstHide = true;
              valView = comply;
            }
            valHide = !valView;
            operactorNext = condiction.operadorCondicion;
            break;
          case 'Ocultar':
            if (!firstHide) {
              if (!operactorNext || operactorNext === 'O') {
                if (valHide || comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              } else {
                if (valHide && comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              }
            } else {
              firstHide = false;
              firstView = true;
              valHide = comply;
            }
            valView = !valHide;
            operactorNext = condiction.operadorCondicion;
            break;
        }
      });
      if (valView || !valHide) {
        valid = true;
      } else {
        valid = false;
      }
    }
    if (!valid) {
      this.documents.forEach(doc => {
        if (doc.funciones && doc.funciones.length) {
          const indexfunction = findIndex(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.generate});
          if (indexfunction !== -1) {
            doc.funciones.splice(indexfunction, 1);
          }
        }
      });
    }
  }

  /**
   * Validacion de las condiciones de un documento para la funcion de radicar
   *
   * @private
   * @param {Array<CondicionDocumento>} condictions - condiciones de la funcion del documento
   * @param {Documento} document - documento
   * @param {string} [funcion='Subir'] - funcion a validar
   * @memberof RadicationDocsComponent
   */
  private validCondictionsDoc(
    condictions: Array<CondicionDocumento>,
    document: Documento,
    funcion: string = 'Subir'
  ) {
    let valid = true;
    if (condictions && condictions.length) {
      let valView = false;
      let valHide = false;
      let firstView = true;
      let firstHide = true;
      let operactorNext = 'O';
      condictions.forEach(condiction => {
        let date = false;
        let comply = false;
        let value: Datos = null;
        let formulario: SubForma;
        let control: Control;
        let valor: any;
        const moment = require('moment');
        if (!Number(condiction.valor) || condiction.fechaActual) {
          if (condiction.valor &&  moment(new Date(String(condiction.valor))).isValid()) {
            date = true;
          } else if (condiction.fechaActual) {
            condiction.valor = new Date();
            date = true;
          } else {
            date = false;
          }
        } else {
          date = false;
        }
        if (this.form && this.form.alias === condiction.forma) {
          formulario = find(this.form.sub_formas, {alias: condiction.formulario});
          if (formulario) {
            control = find(formulario.campos, {alias: condiction.campo});
            if (!formulario.tabla) {
              if (control) {
                if (this.task.datos && this.task.datos.length) {
                  value = find(this.task.datos, {nombre_campo: control.nombre_campo});
                }
              }
            } else {
              valor = [];
              if (control) {
                const table = find(
                  this.task.tabla_datos as TablaDatos[],
                  (t: TablaDatos) => t.alias === condiction.formulario
                );
                if (table && table.valores && table.valores.length) {
                  table.valores.forEach((row: any) => {
                    if (row[table.labels[control.alias]]) {
                      valor.push(row[table.labels[control.alias]]);
                    }
                  });
                }
              }
            }
          }
        } else {
          if (this.task.tarea_asociacion && this.task.tarea_asociacion.length) {
            const tasAssociation = find(this.task.tarea_asociacion, {alias: condiction.forma});
            if (tasAssociation) {
              if (tasAssociation.datos && tasAssociation.datos.length) {
                value = find(tasAssociation.datos, {alias_formulario: condiction.formulario, alias: condiction.campo});
              }
            }
            if (!value) {
              if (this.dataTableAll.length) {
                const table = find(this.dataTableAll, {alias: condiction.formulario});
                if (table) {
                  valor = [];
                  table.valores.forEach((row: any) => {
                    if (row[table.labels[condiction.campo]]) {
                      valor.push(row[table.labels[condiction.campo]]);
                    }
                  });
                }
              }
            }
          }
        }
        if (value) {
          valor = value.valor;
        }
        switch (condiction.siEs) {
          case 'Vacio':
            if (
              !valor ||
              valor === ''
            ) {
              comply = true;
            } else {
              comply = false;
            }
            break;
          case 'Diferente':
            if (!date) {
              if (String(valor).toLowerCase() !== String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl !== valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() !== new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
          case 'Mayor a':
            if (!date) {
              if (Number(valor) > Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl > valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Mayor o igual a':
            if (!date) {
              if (Number(valor) >= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl >= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor a':
            if (!date) {
              if (Number(valor) < Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl < valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
          case 'Menor o igual a':
            if (!date) {
              if (Number(valor) <= Number(condiction.valor)) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              let valorCondiction: Date = null;
              valorCondiction = new Date(condiction.valor);
              dtValorControl = new Date(valor);
              if (value && value.tipo === 'date-time-picker') {
                switch (value.clasificacion) {
                  case 'calendar':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                        dtValorControl.setHours(0, 0, 0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setHours(0, 0, 0, 0);
                    }
                    break;
                  case 'timer':
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setDate(new Date().getDate());
                      dtValorControl.setMonth(new Date().getMonth());
                      dtValorControl.setFullYear(new Date().getFullYear());
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setDate(new Date().getDate());
                      valorCondiction.setMonth(new Date().getMonth());
                      valorCondiction.setFullYear(new Date().getFullYear());
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                  default:
                    if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                    }
                    if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                      valorCondiction.setSeconds(0, 0);
                    }
                    break;
                }
              } else {
                if (dtValorControl && dtValorControl instanceof Date && moment(dtValorControl).isValid()) {
                    dtValorControl.setHours(0, 0, 0, 0);
                }
                if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
                  valorCondiction.setHours(0, 0, 0, 0);
                }
              }
              // Operacion
              if (
                (dtValorControl instanceof Date && moment(dtValorControl).isValid()) &&
                (valorCondiction instanceof Date && moment(valorCondiction).isValid()) &&
                dtValorControl <= valorCondiction
              ) {
                comply = true;
              } else {
                comply = false;
              }
            }
            break;
            case 'Se encuentra en los registros':
              if (!date) {
                const indexExist = valor.indexOf(condiction.valor);
                if (indexExist !== -1) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                const dates = this.calculateDateList(condiction, valor, value);
                let exist: Date;
                if (dates.valueControl && dates.valueControl.length) {
                  exist = find(dates.valueControl, d => {
                    if (
                      (d instanceof Date && moment(d).isValid()) &&
                      (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                      // tslint:disable-next-line: max-line-length
                      d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                    ) {
                      return d;
                    }
                  });
                  if (exist) {
                    comply = true;
                  } else {
                    comply = false;
                  }
                } else {
                  comply = false;
                }
              }
              break;
            case 'No se encuentra en los registros':
              if (!date) {
                const indexExist = valor.indexOf(condiction.valor);
                if (indexExist === -1) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                const dates = this.calculateDateList(condiction, valor, value);
                let exist: Date;
                if (dates.valueControl && dates.valueControl.length) {
                  exist = find(dates.valueControl, d => {
                    if (
                      (d instanceof Date && moment(d).isValid()) &&
                      (dates.valueCondiction instanceof Date && moment(dates.valueCondiction).isValid()) &&
                      // tslint:disable-next-line: max-line-length
                      d.toLocaleDateString() + ' - ' + d.toLocaleTimeString() === dates.valueCondiction.toLocaleDateString() + ' - ' + dates.valueCondiction.toLocaleTimeString()
                    ) {
                      return d;
                    }
                  });
                  if (!exist) {
                    comply = true;
                  } else {
                    comply = false;
                  }
                } else {
                  comply = false;
                }
              }
              break;
          default:
            if (!date) {
              if (String(valor).toLowerCase() === String(condiction.valor).toLowerCase()) {
                comply = true;
              } else {
                comply = false;
              }
            } else {
              let dtValorControl: Date = null;
              if (value && value.tipo && value.tipo === 'date-time-picker') {
                let valorCondiction: string = null;
                let valorControl: string = null;
                const dtValor: Date = new Date(condiction.valor);
                switch (value.clasificacion) {
                  case 'calendar':
                    valorCondiction = dtValor.toLocaleDateString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      valorControl = dtValorControl.toLocaleDateString();
                    }
                    break;
                  case 'timer':
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleTimeString();
                    }
                    break;
                  default:
                    dtValor.setSeconds(0, 0);
                    valorCondiction = dtValor.toLocaleDateString();
                    valorCondiction += ' ' + dtValor.toLocaleTimeString();
                    dtValorControl = new Date(valor);
                    if (moment(dtValorControl).isValid()) {
                      dtValorControl.setSeconds(0, 0);
                      valorControl = dtValorControl.toLocaleDateString();
                      valorControl += ' ' + dtValorControl.toLocaleTimeString();
                    }
                    break;
                }
                if (valorControl === valorCondiction) {
                  comply = true;
                } else {
                  comply = false;
                }
              } else {
                dtValorControl = new Date(valor);
                // tslint:disable-next-line:max-line-length
                if (moment(dtValorControl).isValid() && dtValorControl.toLocaleDateString() === new Date(condiction.valor).toLocaleDateString()) {
                  comply = true;
                } else {
                  comply = false;
                }
              }
            }
            break;
        }
        switch (condiction.accion) {
          case 'Mostrar':
            if (!firstView) {
              if (!operactorNext || operactorNext === 'O') {
                if (valView || comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              } else {
                if (valView && comply) {
                  valView = true;
                } else {
                  valView = false;
                }
              }
            } else {
              firstView = false;
              firstHide = true;
              valView = comply;
            }
            valHide = !valView;
            operactorNext = condiction.operadorCondicion;
            break;
          case 'Ocultar':
            if (!firstHide) {
              if (!operactorNext || operactorNext === 'O') {
                if (valHide || comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              } else {
                if (valHide && comply) {
                  valHide = true;
                } else {
                  valHide = false;
                }
              }
            } else {
              firstHide = false;
              firstView = true;
              valHide = comply;
            }
            valView = !valHide;
            operactorNext = condiction.operadorCondicion;
            break;
        }
      });
      if (valView || !valHide) {
        valid = true;
      } else {
        valid = false;
      }
    }
    if (!valid) {
      const doc = find(this.documents, {clasificacion_id: document.clasificacion_id, idtarea: document.idtarea});
      if (doc) {
        if (doc.funciones && doc.funciones.length) {
          const indexfunction = findIndex(doc.funciones, {funcion: funcion});
          if (indexfunction !== -1) {
            doc.funciones.splice(indexfunction, 1);
          }
        }
      }
    }
  }

  /**
   * Calcula las fechas de la condicion y el valor por el cual se condicionara
   * estas fechas toman el formato indicado por el tipo
   *
   * @private
   * @param {CondicionDocumento} condiction
   * @param {any[]} valor
   * @param {Datos} [value]
   * @returns {DatesCondiction}
   * @memberof RadicationDocsComponent
   */
  private calculateDateList(condiction: CondicionDocumento, valor: any[], value?: Datos): DatesCondiction {
    const dtValorControl: Date[] = [];
    let valorCondiction: Date = null;
    const moment = require('moment');
    valorCondiction = new Date(condiction.valor);
    if (valor && valor.length) {
      valor.forEach(v => {
        dtValorControl.push(new Date(v));
      });
    }
    if (value && value.tipo === 'date-time-picker') {
      switch (value.clasificacion) {
        case 'calendar':
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                  dt.setHours(0, 0, 0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setHours(0, 0, 0, 0);
          }
          break;
        case 'timer':
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                dt.setDate(new Date().getDate());
                dt.setMonth(new Date().getMonth());
                dt.setFullYear(new Date().getFullYear());
                dt.setSeconds(0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setDate(new Date().getDate());
            valorCondiction.setMonth(new Date().getMonth());
            valorCondiction.setFullYear(new Date().getFullYear());
            valorCondiction.setSeconds(0, 0);
          }
          break;
        default:
          if (dtValorControl && dtValorControl.length) {
            dtValorControl.forEach(dt => {
              if (dt && dt instanceof Date && moment(dt).isValid()) {
                dt.setSeconds(0, 0);
              }
            });
          }
          if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
            valorCondiction.setSeconds(0, 0);
          }
          break;
      }
    } else {
      if (dtValorControl && dtValorControl.length) {
        dtValorControl.forEach(dt => {
          if (dt && dt instanceof Date && moment(dt).isValid()) {
              dt.setHours(0, 0, 0, 0);
          }
        });
      }
      if (valorCondiction && valorCondiction instanceof Date && moment(valorCondiction).isValid()) {
        valorCondiction.setHours(0, 0, 0, 0);
      }
    }
    return {valueCondiction: valorCondiction, valueControl: dtValorControl};
  }

  /**
   * Valida que todos los documentos para radicar obligatorios esten radicados
   * Emite el evento dela validacion
   *
   * @private
   * @memberof RadicationDocsComponent
   */
  private validateRadicateDocuments() {
    let val = false;
    for (const doc of this.documents) {
      const funcion = find(doc.funciones, {funcion: Const.DOCUMENTS_FUNCTIONS.radication});
      if (funcion) {
        if (funcion.obligatorio || (doc.documentos_detalle.length && doc.documentos_detalle[0].radicado)) {
          if (doc.documentos_detalle.length) {
            if (doc.documentos_detalle[0].radicado) {
              if (doc.expediente) {
                val = true;
              } else {
                if (!doc.documentos_detalle[0].documento_cita) {
                  if (!this.notUploadDocument) {
                    if (doc.documentos_detalle[0].historial.length) {
                      const historyDoc = find(doc.documentos_detalle[0].historial, {radicado: true});
                      if (historyDoc) {
                        val = true;
                      } else {
                        val = false;
                        break;
                      }
                    } else {
                      val = false;
                      break;
                    }
                  } else {
                    val = true;
                  }
                } else {
                  val = true;
                }
              }
            } else {
              val = false;
              break;
            }
          } else {
            val = false;
            break;
          }
        } else {
          val = true;
        }
      } else {
        val = true;
      }
    }
    this.radicateCompleted.emit(val);
  }

  /**
   * Actualiza los documentos de la tarea
   * Emite la tarea actualizada
   *
   * @private
   * @memberof RadicationDocsComponent
   */
  private updateDocuments() {
    const copyDocuments: Documento[] = Static.copyObjet(this.documents);
    this.task.documentos.map((document, index) => {
      const doc = find(copyDocuments, {idtarea: this.task.id, clasificacion_id: document.clasificacion_id});
      if (doc) {
        doc.funciones = document.funciones;
        this.task.documentos[index] = doc;
      }
    });

    this.task.tarea_asociacion.forEach((association, index) => {
      association.documentos.map((document, indexDoc) => {
        const doc = find(copyDocuments,
          {
            idtarea: association.id_tarea_destino,
            clasificacion_id: document.clasificacion_id
          }
        );
        if (doc) {
          doc.funciones = document.funciones;
          this.task.tarea_asociacion[index].documentos[indexDoc] = doc;
        }
      });
    });

    this.taskUpdate.emit(this.task);
  }

  /**
   * Controla la accion de precargar el documento para subirlo
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  private onAdded(data: any): any {
    let replace = false;
    for (let i = 0; i < this.documentsUpload.length; i++) {
      if (this.documentsUpload[i]['clasificacion_documento_id'] === this.rowSelect.clasificacion_id) {
        replace = true;
        this.formData.delete(this.documentsUpload[i]['file']);
        this.documentsUpload[i]['file'] = data.file.name;
        break;
      }
    }
    this.formData.append(data.file.name, data.file);
    if (!replace) {
      const dataD = {
        clasificacion_documento_id: this.rowSelect.clasificacion_id,
        file: data.file.name,
        id_tarea: this.rowSelect.idtarea,
      };

      if (this.rowSelect.documentos_detalle.length > 0) {
        dataD['id_documento'] = this.rowSelect.documentos_detalle[0].id_documento;
        dataD['radicado'] = this.rowSelect.documentos_detalle[0].radicado;
      }
      this.documentsUpload.push(dataD);
    }
  }

  /**
   * Remueve el documento precargado
   *
   * @private
   * @param {*} data
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  private onRemoved(data: any): any {
    this.formData.delete(data.file.name);
    for (let i = 0; i < this.documentsUpload.length; i++) {
      if (this.documentsUpload[i]['file'] === data.file.name) {
        this.documentsUpload.splice(i, 1);
      }
    }
  }

  /**
   * Genera el documento seleccionado
   *
   * @private
   * @param {*} data
   * @memberof RadicationDocsComponent
   */
  private generateDocument(data: any) {
    const dataDocument = {
      tarea: data.idtarea,
      documento: data.clasificacion_id
    };

    this.rdds.generateDocument(dataDocument).subscribe(file => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = file.url.path;
      a.download = file.url.name;
      a.click();
      a.remove();
    });

  }

  /**
   * Emite el evento de regresar
   *
   * @returns {*}
   * @memberof RadicationDocsComponent
   */
  closeComponent(): any {
    this.close.emit(true);
  }

  /**
   * Controla el cambio de tipo de radicación
   *
   * @param {*} data
   * @memberof RadicationDocsComponent
   */
  changeTypeRadication(data: any) {
    this.searchRadications = [];
    switch (data.target.value) {
      case 'associate':
        this.generateRadicate = false;
        break;
      default:
        this.generateRadicate = true;
        break;
    }
  }

  /**
   * Controla el cambio de la selección de radicación
   *
   * @param {*} data
   * @memberof RadicationDocsComponent
   */
  changeDependencie(data: any) {
    this.selectedDependencie = data.id;
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/radication-docs/radication-docs.component.ts